import { baseApi } from "api/BaseApi";
import { Option } from "api/common/types/common.types";
import { PaginatedResponse } from "api/common/types/response.types";

import {
  ExpandedEcrAssignmentReportByProductId,
  ExpandedEcrAssignmentFilters,
} from "./expandedEcrAssignment.types";

const EXPANDED_ECR_ASSIGNMENT_BASE_URL = "project/product/";

const expandedEcrAssignmentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    expandedEcrAssignment: build.query<
      PaginatedResponse<ExpandedEcrAssignmentReportByProductId>,
      ExpandedEcrAssignmentFilters
    >({
      query: (params) => ({
        url: `${EXPANDED_ECR_ASSIGNMENT_BASE_URL}get_expanded_ecr_assignment_report/`,
        params,
      }),
      providesTags: ["EXPANDED_ECR_ASSIGNMENT"],
    }),

    expandedEcrAssignmentParticipatingOrgs: build.query<Option[], void>({
      query: () => ({
        url: `${EXPANDED_ECR_ASSIGNMENT_BASE_URL}get_expanded_ecr_assignment_report_participating_orgs/`,
      }),
      transformResponse: (response: { org_id: number; name: string }[]) => {
        return response.map((org) => {
          // For orgs, create label as "NIAP/OrgName"
          const simplifiedName = org.name.includes(
            "National Information Assurance Partnership",
          )
            ? "CCEVS"
            : org.name.includes("Johns Hopkins")
              ? "JHUAPL"
              : org.name.includes("Aerospace")
                ? "Aerospace"
                : org.name.includes("MITRE")
                  ? "MITRE"
                  : org.name; // fallback to full name

          return {
            label: `NIAP/${simplifiedName}`,
            value: org.org_id,
          };
        });
      },
    }),
  }),

  overrideExisting: false,
});

export const {
  useExpandedEcrAssignmentQuery,
  useExpandedEcrAssignmentParticipatingOrgsQuery,
} = expandedEcrAssignmentApi;
